<template>
  <v-card>
    <v-form @submit.prevent="submitEditSpoil()" ref="editSpoilForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Edit'" :details="spoil.name"></dialog-header>
          <v-flex xs12>
            <v-text-field label="* Name" v-model="editedSpoil.name" :rules="nameRules" autofocus></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              :items="spoilTypes"
              color="indigo"
              v-model="editedSpoil.type"
              :rules="typeRules"
              label="Type"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 v-if="$store.state.user.userAuthClass.name === 'Administrator'">
            <v-switch label="Request" v-model="editedSpoil.request" :disabled="!userAuthClass"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn color="grey darken-2" flat @click="discard()">Discard?</v-btn>
          <v-btn color="green" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn color="grey darken-2" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
    <v-container v-if="!editedSpoil.request">
      <v-layout>
        <v-flex>
          <v-expansion-panel expand class="grey lighten-3">
            <v-expansion-panel-content v-model="tipPanel" class="grey lighten-4">
              <div
                slot="header"
                class="font-weight-medium grey--text text--darken-2 vertical-center-container"
              >
                <v-icon :color="color" class="mr-2">{{this.$store.state.global.pages.tip.icon}}</v-icon>Allowed Tips
              </div>

              <v-list subheader>
                <v-list-tile v-for="tip in tips" :key="tip.id" fluid>
                  <v-checkbox
                    v-model="selectedTips"
                    :label="tip.name"
                    :value="tip.id"
                    :color="color"
                  ></v-checkbox>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-checkbox v-model="selectAllTips" :color="color">
                    <div slot="label" class="font-weight-bold">Select All</div>
                  </v-checkbox>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import SpoilService from '@/services/requests/spoilService'
import TipSpoilService from '@/services/requests/tipSpoilService'

// MIXINS
import SpoilValidation from '@/services/validation/spoilValidation'
import RouteProps from '@/services/mixins/routeProps'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'

export default {
  mixins: [SpoilValidation, RouteProps],
  components: {
    DialogHeader,
  },
  data() {
    return {
      tipSpoils: [],
      selectedTips: [],
      currentTips: [],
      allTips: [],
      editedSpoil: Object.assign({}, this.spoil),
      loading: false,
      selectAllTips: false,
      tipPanel: false,
      color: this.$store.state.global.pages.tip.color,

      spoilTypes: [
        {
          text: 'Spoil',
          value: 'SPL',
        },
        {
          text: 'Toll',
          value: 'TOL',
        },
        {
          text: 'Internal Use',
          value: 'INT',
        },
      ],
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    discard() {
      this.editedSpoil = Object.assign({}, this.spoil)
      this.selectedTips = this.currentTips
      this.close()
    },
    submitEditSpoil() {
      if (!this.$refs.editSpoilForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.save()
    },
    getTipSpoilsBySpoil() {
      TipSpoilService.getTipSpoilsBySpoil(this.spoil.id)
        .then((result) => {
          if (result.data.result.length) {
            this.setCurrentTips(result.data.result)
          }
          this.tipSpoils = result.data.result
        })
        .catch((err) => {
          this.snackError()
          console.log(err)
        })
    },
    setCurrentTips(data) {
      this.selectedTips = []
      this.currentTips = []
      for (var record of data) {
        this.selectedTips.push(record.tipId)
        this.currentTips.push(record.tipId)
      }
    },

    save() {
      var postedSpoil = this.editedSpoil
      postedSpoil.selectedTips = this.selectedTips

      this.loading = true
      SpoilService.updateSpoil(this.editedSpoil)
        .then((result) => {
          this.loading = false
          this.$store.commit('spoils/updateArrayStateByValue', {
            prop: 'spoils',
            value: this.spoil,
            editedValue: result.data.result.spoil,
          })
          this.editedSpoil = Object.assign({}, result.data.result.spoil)
          this.setCurrentTips(result.data.result.tipSpoils)
          this.snack({ text: 'Spoil was edited!', color: 'green' })
          this.close()
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
          this.snackError()
        })
    },
  },
  computed: {
    tips: Store.getSet({ store: 'tips', prop: 'tips' }),
    different() {
      if (
        !this._.isEqual(this.spoil, this.editedSpoil) ||
        !this._.isEqual(
          this.selectedTips.sort().join(','),
          this.currentTips.sort().join(',')
        )
      ) {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    this.getTipSpoilsBySpoil()
    for (var tip of this.tips) {
      this.allTips.push(tip.id)
    }
  },
  props: {
    spoil: Object,
  },
  watch: {
    selectAllTips(val) {
      val ? (this.selectedTips = this.allTips) : (this.selectedTips = [])
    },
  },
}
</script>

<style>
</style>
